import React from "react";
import FooterVariant1 from "../components/Footer/Variant1"
import FooterVariant2 from "../components/Footer/Variant2"
import FooterVariant3 from "../components/Footer/Variant3"

export const footer_library = {
  footer: {
    variant1: {
      name: "Simple Footer",
      description: "Minimal footer with branding.",
      Component: React.memo(FooterVariant1),
      metadata: {
        tokens: {
          company_heading: { type: "text", default: "Company" },
          company_1: { type: "text", default: "About" },
          company_2: { type: "text", default: "Careers" },
          company_3: { type: "text", default: "Contact" },
          company_4: { type: "text", default: "Blog" },

          resources_heading: { type: "text", default: "Resources" },
          resources_1: { type: "text", default: "Documentation" },
          resources_2: { type: "text", default: "Support" },
          resources_3: { type: "text", default: "API Status" },
          resources_4: { type: "text", default: "Guides" },
          legal_1: { type: "text", default: "Privacy" },
          legal_2: { type: "text", default: "Terms" },
          legal_3: { type: "text", default: "Security" },

          subscribe_heading: { type: "text", default: "Subscribe" },
          subscribe_text: {
            type: "text",
            default: "Stay updated with our        newsletter",
          },
          email_placeholder: { type: "text", default: "Your email" },
          subscribe_button: { type: "text", default: "Join" },

          copyright: {
            type: "text",
            default: "© 2025 Company Name. All rights reserved.",
          },
        },
      },
    },
    variant2: {
      name: "Extended Footer",
      description: "Footer with multiple sections and links.",
      Component: React.memo(FooterVariant2),
      metadata: {
        tokens: {
          heading: { type: "text", default: "Stay in the loop" },
          description: {
            type: "text",
            default:
              "Subscribe to our newsletter for the latest updates and resources.",
          },
          emailPlaceholder: { type: "text", default: "Enter your email" },
          subscribeButton: { type: "text", default: "Subscribe" },
          link1: { type: "text", default: "Privacy" },
          link2: { type: "text", default: "Terms" },
          link3: { type: "text", default: "Support" },
          link4: { type: "text", default: "Contact" },
          copyright: {
            type: "text",
            default: "© 2025 Your Company. All rights reserved.",
          },
        },
      },
    },
    variant3: {
      name: "Contact Footer",
      description: "Footer with contact form and social links.",
      Component: React.memo(FooterVariant3),
      metadata: {
        tokens: {
          brandName: { type: "text", default: "BrandName" },
          about: {
            type: "text",
            default:
              "Empowering developers with beautiful UI components and tools.",
          },
          quickLinksTitle: { type: "text", default: "Quick Links" },
          link1: { type: "text", default: "Home" },
          link2: { type: "text", default: "Docs" },
          link3: { type: "text", default: "Pricing" },
          link4: { type: "text", default: "Blog" },
          followUs: { type: "text", default: "Follow Us" },
          copyright: {
            type: "text",
            default: "© 2025 BrandName. Crafted with care.",
          },
        },
      },
    },
  },
};
